export default __webpack_public_path__ + "static/media/gustavo-gandino-1.dd037bfb.webp";